import React from 'react'
import { makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import { selectRenderValueStyles } from './selectRenderValue.styles'
import COLORS from '../../utils/constants/colors'
import DefaultOrgIcon from '../../assets/icons/DefaultOrgIcon'
import orgType from '../../types/orgType'
import teamType from '../../types/teamType'
import LiteModeBadge from '../LiteModeBadge/LiteModeBadge'

const SelectRenderValue = (props) => {
  const { item, chosenOption, logoArgName, labelBlack } = props
  const useStyles = makeStyles(selectRenderValueStyles)
  const classes = useStyles()

  if (!item) return null

  // Support both teamLogo and teamLogoUrl for compatibility with different API responses
  // AFTER REMOVAL OF logoUrl  change line bellow
  const logoUrl = item[logoArgName] || item['teamLogoUrl'] || (logoArgName === 'teamLogo' ? item.teamLogoUrl : null)

  return (
    <div className={classes.wrapper}>
      {logoUrl ? (
        <img src={logoUrl} alt='logo' className={classes.img} />
      ) : (
        <DefaultOrgIcon className={classes.orgIcon} />
      )}
      <span
        style={{
          color: chosenOption?.id === item.id && !labelBlack ? COLORS.orange : '#555555',
        }}
      >
        {item.name}
      </span>
      <LiteModeBadge statsMode={item.statsMode} />
    </div>
  )
}

SelectRenderValue.propTypes = {
  item: orgType,
  chosenOption: orgType || teamType,
  logoArgName: PropTypes.string,
  labelBlack: PropTypes.bool,
}

export default SelectRenderValue
